import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { Alert, message } from 'antd'
import FormComponent from './Form'
import { client } from '@utils/client'
import moment from 'moment'
import Modal from '@components/Modal'
import Text from '@components/Text'
import { wellKidzClubECoupon } from './List'

const Edit = (props) => {
  const { setOpen, open, defaultValues, reload } = props
  const { t } = useLocalization()
  const [errorMessage, setErrorMessage] = useState()

  /**
   * @type {{
   * header: React.CSSProperties
   * bodyModalStyle: React.CSSProperties
   * }}
   */

  const style = {
    header: { fontWeight: '700' },
    bodyModalStyle: {
      display: 'flex',
      flexDirection: 'column',
      padding: 16,
      overflowY: 'hidden',
      gap: 16,
      maxHeight: 850,
    },
  }

  const handleSubmit = async (data) => {
    const convertData = { ...data }
    convertData.startAt = data.startAt.format('YYYY-MM-DD')
    convertData.expiredAt = data.expiredAt.format('YYYY-MM-DD')
    convertData.typePermissionCouponLimit = Number(
      data.typePermissionCouponLimit
    )
    if (convertData.typePermissionCoupon === 'UnLimit') {
      convertData.typePermissionCouponLimit = 0
    }
    delete convertData.id
    try {
      await client.patch(`/coupons/${data.id}`, convertData)
      message.success('สำเร็จ')
      reload()
      setOpen(false)
    } catch (e) {
      if (
        e.response.data.message ===
        'Expiration date must be after the start date'
      ) {
        setErrorMessage('วันหมดอายุต้องอยู่หลังวันที่เริ่มต้น')
      } else if (
        e.response.data.message ===
        `Cannot update typePermissionCouponLimit: total usage count exceeds the limit`
      ) {
        setErrorMessage(
          `จำนวนสิทธิ์ที่ถูกจำกัดต้องไม่น้อยกว่า ${defaultValues.usageCount} สิทธิ์`
        )
      } else if (
        e.response &&
        e.response.data &&
        e.response.data.message ===
          `typePermissionCouponLimit can't be null if typePermissionCoupon === Limit`
      ) {
        setErrorMessage('จำนวนสิทธิ์ที่ถูกจำกัดต้องมากกว่า 0 สิทธิ์')
      } else if (e.response) {
        setErrorMessage(e.response.data.message)
      }
      message.error('ไม่สำเร็จ')
    }
  }

  //เเปลงวันที่กลับเป็น moment ก่อนเสดงข้อมูลที่ Field
  defaultValues.startAt = moment(defaultValues.startAt)
  defaultValues.expiredAt = moment(defaultValues.expiredAt)

  const reset = () => {
    setErrorMessage(undefined)
  }
  const formMemo = useMemo(() => {
    return (
      <FormComponent
        handleSubmit={handleSubmit}
        doStatus="edit"
        defaultValues={defaultValues}
      />
    )
  }, [defaultValues])
  return (
    <>
      <Modal
        centered={false}
        open={open}
        onCancel={() => setOpen(false)}
        closable={true}
        maskClosable={false}
        // footer={null}
        width={800}
        style={{ top: 20 }}
        bodyStyle={style.bodyModalStyle}
      >
        <Text level={1} style={style.header}>
          {t(`${wellKidzClubECoupon}.editECoupon`)}
        </Text>
        {errorMessage && (
          <Alert
            message={errorMessage}
            type="error"
            showIcon
            closable
            onClose={reset}
          />
        )}
        {formMemo}
      </Modal>
    </>
  )
}

Edit.propTypes = {
  defaultValues: PropTypes.object,
  reload: PropTypes.func,
  setOpen: PropTypes.func,
  open: PropTypes.bool,
}

export default Edit
